import React from 'react'
import { Outlet } from 'react-router-dom'
import MarketNavbar from './pages/Market/MarketNavbar'
import Footer from '../layout/Footer'

const RootLayout = () => {
    return (
        <section className='flex flex-col justify-between w-full min-h-screen'>
            <MarketNavbar />
            <main className='flex-1'>
                <Outlet />
            </main>
            <Footer />
        </section>
    )
}

export default RootLayout
